// Mapper: transport LC_GetTodayMarksSummaryOut → domain model for the
// "Mi equipo" dashboard "Situación de asistencia" section — "Marcajes" card
// (ASIS-5407 / REXASIS-006).
// The backend only sends the raw counts; the percentage/isEmpty business rules are
// computed here so the UI never re-implements them.

import type {
  LC_GetTodayMarksSummaryOut,
  MyTeamMarksSummary,
} from '../types/myTeamMarksSummary.types';


export function mapMyTeamMarksSummary(
  out: LC_GetTodayMarksSummaryOut,
): MyTeamMarksSummary {
  const totalMarksCount = out.inPersonCount + out.remoteCount;
  const isEmpty = out.totalSupervisedCount === 0 || totalMarksCount === 0;
  const percentageInPerson = isEmpty
    ? 0
    : Math.round((out.inPersonCount / totalMarksCount) * 100);
  // percentageRemote is derived from the complement (not rounded independently) so
  // the two donut segments always add up to 100% instead of drifting to 99%/101%.
  const percentageRemote = isEmpty ? 0 : 100 - percentageInPerson;

  return {
    inPersonCount: out.inPersonCount,
    remoteCount: out.remoteCount,
    totalSupervisedCount: out.totalSupervisedCount,
    percentageInPerson,
    percentageRemote,
    isEmpty,
  };
}
